module.exports = "/images/eliminar.svg";